import { render, staticRenderFns } from "./default.vue?vue&type=template&id=27a110ba"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WebsiteFooter: require('/vercel/path0/components/website-footer.vue').default})
